/**
 * Registro dos manuais da plataforma.
 *
 * PARA ADICIONAR UM MANUAL: crie o componente em `features/manuals/`, registre a rota
 * `/manuais/<slug>` em `routes/router.tsx` e acrescente uma entrada aqui. O índice em `/manuais`
 * monta sozinho a partir desta lista.
 */

export interface Manual {
  slug: string;
  titulo: string;
  resumo: string;
  area: string;
  /** Papéis que enxergam. Ausente = todos. */
  papeis?: string[];
  /** YYYY-MM-DD. */
  atualizado: string;
}

export const MANUAIS: Manual[] = [
  {
    slug: 'alarmes-personalizados',
    titulo: 'Alarmes personalizados',
    resumo:
      'Como transformar qualquer informação que o rastreador envia, uma entrada, um sensor, uma leitura de motor, em um alarme com nome próprio que dispara aviso.',
    area: 'Alertas e notificações',
    papeis: ['admin', 'revenda'],
    atualizado: '2026-08-10',
  },
];

export const manualHref = (m: Manual): string => `/manuais/${m.slug}`;

export const manuaisVisiveis = (papel: string | null): Manual[] =>
  MANUAIS.filter((m) => !m.papeis || (papel != null && m.papeis.includes(papel)));
